export { default } from './CategoryEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Category/CategoryEdit/index.js